<template>
    <v-container fluid>
    <v-snackbar
      v-model="snackbar"
      :color="snackbarColor"
      :top="true"
      :right="true"
      :timeout="-1"
      absolute
      >
      {{ message }}
      <v-btn
        dark
        text
        @click="snackbar = false"
      >
        CLOSE
      </v-btn>
     </v-snackbar>

      <v-layout class="main-layout">
      <v-flex xs12>
        <v-card>
          <v-card-text>
            <v-layout>
              <v-flex xs3>
                <span class="accent--text" style="font-size: 14px; font-weight:700;"> Broker Charges </span>
              </v-flex>
              <v-spacer>
              </v-spacer>
              <v-flex xs3>
                <v-text-field label="Search" v-model="search">
                </v-text-field>
              </v-flex>
            </v-layout>
            <v-data-table
              :headers="headers"
              :items="brokerCharges"
              :items-per-page="5"
              :search="search"
              class="elevation-1"
            >
			<template v-slot:item.documentUpload.fileName="{ item }">
                <a
                  href="#"
                  class="primary--text"
                  @click.prevent="downloadContractPDF(item)"
                >
                  {{ item.documentUpload.fileName }}
                </a>
              </template>
              <template v-slot:item.partyBApprovalTime="{ item }">
                {{ formatTimestamp(item.partyBApprovalTime) }}
              </template>
              <template v-slot:item.nceApprovalTime="{ item }">
                {{ formatTimestamp(item.nceApprovalTime) }}
              </template>
              <template v-slot:item.coopApprovalTime="{ item }">
                {{ formatTimestamp(item.coopApprovalTime) }}
              </template>
            <template v-slot:item.dateCreated="{ item }">
                {{item.contractStartDate | prettyDate }}
            </template>
              <template v-slot:item.expiryDate="{ item }">
                {{item.contractEndDate | prettyDate }}
              </template>
	<template v-slot:item.documentUpload.fileName="{ item }">

			<a href="#" class="primary--text" @click.prevent="downloadContractPDF(item)">
				{{item.documentUpload.fileName}}
				</a>

						  </template>
            </v-data-table>
          </v-card-text>
        </v-card>
      </v-flex>

      </v-layout>
    </v-container>
    </template>
<script>
import axios from 'axios'
import config from '../../../config'
import store from '../../../store'
import http from '../../../http'
import { mapState } from 'vuex'

export default {
	name: 'catalogueupload',
	data: function () {
		return {
			gradeDisabled: true,
			brokerCharges: [],
			editFarmerType: {},
			editCoffeeType: {},
			editGrade: {},
			editStatus: '',
			cherryRateTemp: { rate: 0, name: 'hello' },
			headers: [
				{ text: 'Upload Org', value: 'documentUpload.organisation.organisationName' },
				{ text: 'Upload Date', value: 'documentUpload.dateCreated' },
				{ text: 'Upload User', value: 'documentUpload.createdBy' },
				{ text: 'Counter Party Name', value: 'partyBorg.organisationName' },
				{ text: 'Approving User', value: 'partyB.username' },
				{ text: 'Approval Date', value: 'partyBApprovalTime' },
				{ text: 'NCE Approver', value: 'nceApprover' },
				{ text: 'NCE Approval Date', value: 'nceApprovalTime' },
				{ text: 'BANK Approver', value: 'coopApprover' },
				{ text: 'BANK Approval Date', value: 'coopApprovalTime' },
				{ text: 'Grower', value: 'grower.organisationName' },
				{ text: 'GrowerCode', value: 'grower.organisationCode' },
				{ text: 'Marketer', value: 'marketer.organisationName' },
				//   { text: 'Warehouse', value: 'warehouse.name' },
				{ text: 'Charge Rate', value: 'chargeRate' },
				{ text: 'Start Date', value: 'dateCreated' },
				{ text: 'End Date', value: 'expiryDate' },
				{ text: 'Status', value: 'status.description' },
				{ text: 'Contract', value: 'documentUpload.fileName' }
				//   { text: 'Milling Charge', value: 'millingCharge' },
				//   { text: 'Export Bag Charge', value: 'exportBagCharge' },
				//   { text: 'Actions', value: 'actions', sortable: false }
			],
			valid: true,
			message: '',
			snackbar: false,
			snackbarColor: '',
			file: '',
			files: [],
			pagination: { sortBy: 'id', descending: true },
			search: '',
			permissions: [],
			previewLoading: false,
			approveloading: false,
			declineloading: false,
			paginatedFiles: [],
			numberOfLinks: 0,
			numberOfItemsPerPage: 7,
			page: 1,
			confirmDialog: false,
			confirmFile: {},
			confirmMessage: '',
			action: '',
			rateLimitDialog: false,
			editRateLimitDialog: false,
			approveRateLimitDialog: false,
			userID: 0
		}
	},
	mounted () {
		this.getBrokerCharges()
		this.permissions = store.state.user.roleId.permissions
	},
	watch: {
		files () {
			this.paginatedFiles = this.paginationMethod(this.files, 1, this.numberOfItemsPerPage)
			this.numberOfLinks = Math.ceil(this.files.length / this.numberOfItemsPerPage)
		},
		page: function (val) {
			this.paginatedFiles = this.paginationMethod(this.files, val, this.numberOfItemsPerPage)
		}
	},
	computed: {
		...mapState({ user: state => state.user }),
		canUploadFarmers: function () {
			return this.hasPerm('CAN_UPLOAD_FARMERS')
		},
		canCreateRate: function () {
			return this.hasPerm('CAN_CREATE_CCARF_RATE')
		},
		canUpdateRate: function () {
			return this.hasPerm('CAN_UPDATE_CCARF_RATE')
		},
		canApproveCatalogue: function () {
			return this.hasPerm('CAN_APPROVE_CATALOGUE')
		},
		filteredList: function () {
			if (this.search === '') {
				return this.paginatedFiles
			} else {
				return this.files.filter(file => { return file.fileName.toLowerCase().includes(this.search.toLowerCase()) })
			}
		}
	},
	methods: {
		formatTimestamp (timestamp) {
			if (timestamp === null || timestamp === undefined || timestamp === '') {
				return ''
			}
			const date = new Date(timestamp)
			const year = date.getFullYear()
			const month = ('0' + (date.getMonth() + 1)).slice(-2) // Add 1 because months are 0-indexed
			const day = ('0' + date.getDate()).slice(-2)
			const hours = ('0' + date.getHours()).slice(-2)
			const minutes = ('0' + date.getMinutes()).slice(-2)
			return `${month}/${day}/${year} ${hours}:${minutes}`
		},
		downloadContractPDF (file) {
			console.log("filesss -> ", file)
			// Base64 encoded string of a small PDF file
			const base64String = file.documentUpload.file

			// This function converts a base64 string to a Blob
			function base64ToBlob (base64, type) {
				const binary = atob(base64.replace(/\s/g, ''))
				const len = binary.length
				const buffer = new ArrayBuffer(len)
				const view = new Uint8Array(buffer)
				for (let i = 0; i < len; i++) {
					view[i] = binary.charCodeAt(i)
				}
				return new Blob([view], { type: type })
			}

			const blob = base64ToBlob(base64String, 'application/pdf')
			const url = window.URL.createObjectURL(blob)

			const downloadLink = document.createElement('a')
			downloadLink.href = url
			downloadLink.setAttribute('download', file.documentUpload.fileName + '.pdf')
			document.body.appendChild(downloadLink)
			downloadLink.click()

			// Clean up
			window.URL.revokeObjectURL(url)
			document.body.removeChild(downloadLink)
		},
		canBeApproved (item) {
			return item.status.id === 3 && this.hasPerm('CAN_APPROVE_FARMERS')
		},
		canBeDeclined (item) {
			return item.status.id === 3 && this.hasPerm('CAN_APPROVE_FARMERS')
		},
		paginationMethod (items, pageNumber, limitPerPage) {
			pageNumber = pageNumber - 1
			const from = pageNumber * limitPerPage
			let to = (pageNumber + 1) * limitPerPage
			if (to >= items.length) {
				to = items.length
			}
			return items.slice(from, to)
		},
		hasPerm (permission) {
			return this.permissions.includes(permission)
		},
		handleFileUpload () {
			this.file = this.$refs.file.files[0]
		},
		openCreateDialog () {
			this.rateLimitDialog = true
		},
		getBrokerCharges () {
			http.get(config.serverURI + '/broker/findAll')
				.then(response => {
					this.brokerCharges = response.data
					this.brokerCharges.forEach(x => {
						if (x.status.statusName === 'PENDING_CHECKER_APPROVAL') {
							const creatingOrg = x.creatingOrganisation.organisationName
							console.log('creatingOrg ', creatingOrg)
							const org = x.marketer.organisationName
							console.log('org ', org)
							const grower = x.grower.organisationName
							console.log('grower--- ', grower)
							let name = 'PENDING ' + org + ' APPROVAL'
							console.log('name33555--- ', name)
							if (creatingOrg === org) {
								name = 'PENDING ' + grower + ' APPROVAL'
							}
							console.log('name--->>> ', name)
							x.status.description = name
							console.log('name--->>>3 ', x.status.description)
						}
						// if (x.nceApprovalTime !== null) {
						// 	console.log('helli ===> ', x.nceApprovalTime)
						// 	const dte = new Date(x.nceApprovalTime)
						// 	const formattedDate = `${('0' + (dte.getMonth() + 1)).slice(-2)}/${('0' + dte.getDate()).slice(-2)}/${dte.getFullYear()} ` +
						//     `${('0' + dte.getHours()).slice(-2)}:${('0' + dte.getMinutes()).slice(-2)}:${('0' + dte.getSeconds()).slice(-2)}`
						// 	x.nceApprovalTime = formattedDate
						// }
						// if (x.coopApprovalTime !== null) {
						// 	const dte = new Date(x.nceApprovalTime)
						// 	const formattedDate = `${('0' + (dte.getMonth() + 1)).slice(-2)}/${('0' + dte.getDate()).slice(-2)}/${dte.getFullYear()} ` +
						//     `${('0' + dte.getHours()).slice(-2)}:${('0' + dte.getMinutes()).slice(-2)}:${('0' + dte.getSeconds()).slice(-2)}`
						// 	x.coopApprovalTime = formattedDate
						// }
						// if (x.partyBApprovalTime !== null) {
						// 	const dte = new Date(x.nceApprovalTime)
						// 	const formattedDate = `${('0' + (dte.getMonth() + 1)).slice(-2)}/${('0' + dte.getDate()).slice(-2)}/${dte.getFullYear()} ` +
						//     `${('0' + dte.getHours()).slice(-2)}:${('0' + dte.getMinutes()).slice(-2)}:${('0' + dte.getSeconds()).slice(-2)}`
						// 	x.partyBApprovalTime = formattedDate
						// }
					})
					console.log('RR -> ', response.data)
				})
				.catch(error => {
					console.log('error', error)
					this.$store.dispatch('alert/displayAlert', { snackbar: true, color: 'error', message: error.response ? error.response.data.message : 'Error ocurred' }, { root: true })
				})
		}
	}
}

</script>
    <style>
    .main-layout {
      margin-top: 15px;
    }
    .farmers_box_empty {
      position: relative;
      background: #fff;
      border: 1px solid #707070;
    }

    .btn{
      padding: 10px;
      margin: 5px;
    }
    .farmers_box {
      position: relative;
      background: #fff;
      border: 1px solid #707070;
    }
    .thead {
      background-color: #00513B !important;
      color: white;
      font-size: 12px;
    }

    .table  tbody  tr >  td.actions {
      font-size: 20px !important;
      color: #733D29 !important;
      padding-top: 0px;
    }
    .pagination {
      background-color: red;
    }
    .paginationtext {
      color: #733D29;
    }

    .pagination>li>a,
    .pagination>li>span {
      border: 1px solid #F2D0A7;
      color: #733D29;
    }
    .pagination>li.active>.page-link {
      background: #00513B;
      color: #fff;
    }

    select {
      border: 1px solid #000;
      color: black;
      padding: 10px;
    }

    v-col{
      border: 1px solid brown;
    }
    </style>
